export const ANIMAL_PER_PORT_URL = 'dashboard/animal_per_port'
export const ANIMAL_PER_PORT_ERROR = 'ANIMAL_PER_PORT_ERROR'
export const ANIMAL_PER_PORT_LOADING = 'ANIMAL_PER_PORT_LOADING'
export const ANIMAL_PER_PORT_SUCCESS = 'ANIMAL_PER_PORT_SUCCESS'